<div class="main-container">
  <div  [ngClass]="{'singleToken': IssingleToken, 'multiToken': isMultiToken}">
    @for (d of screen; track d; let i = $index) {
      <div [ngClass]="{'active': i==activeSlideIndex, 'inactive': i!=activeSlideIndex}">
        @for (r of d; track r) {
          <div class="token-queue-view float-left mx-2" [ngStyle]="calculateStyles(d.length ,d)">
            <div class="deskcard">
              <div [ngClass]="getServiceInfo(r) ? 'card-body card-view' : 'card-view_only_token'">
                <img src="assets/images/Queue.svg" class="token-icon">
                <label class="token-hd"> {{r.desk_name}}</label>
              </div>
            </div>
            @for (p of r.queueDeskMapping; track p) {
              <div class="cardtoken">
                <div [ngClass]="getServiceInfo(r) ? 'card-deatails' : ' '">
                  <div   [ngClass]="{ 'card-view-token_p': getServiceInfo(r), 'hide-token-details': !getServiceInfo(r), 'bg-green': p.stage == 'Serving', 'queue-bg': p.stage != 'Serving'}">
                    @if (p.uhId) {
                      <div>
                        <label>{{'field.label.uhId' | translate | async}}</label><br />
                        <div>{{ p.uhId }}</div>
                        <hr />
                      </div>
                    }
                    @if (p.token && p.appointmentId) {
                      <div>
                        <label>{{'field.label.queue_no' | translate | async}}</label><br />
                        <div>{{ p.token }}</div>
                        <hr />
                      </div>
                    }
                    @if (p.token && !p.appointmentId) {
                      <div class="apptToken">
                        <div>{{ p.token }}</div>
                      </div>
                    }
                    @if (p.appointmentId) {
                      <div>
                        <label>{{'field.label.appointment_id' | translate | async}}</label><br />
                        <div>{{ p.appointmentId }} </div>
                        <hr />
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @for (r of d; track r) {
              <div class="token-screen-view ml-2" [ngStyle]="calculateStyles(d.length)">
                <div class="deskcard" (click)="gettokenslist(r)">
                  <div class="card-body card-view">
                    <div>{{r.desk_name}}</div>
                    <div style="margin-left: auto;">
                      @if (!tokensList) {
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                      }
                      @if (r.desk_name == deskName && tokensList) {
                        <i class="fa fa-angle-down"
                        aria-hidden="true"></i>
                      }
                      @if (r.desk_name != deskName && tokensList) {
                        <i class="fa fa-angle-right"
                        aria-hidden="true"></i>
                      }
                    </div>
                  </div>
                </div>
                @if (r.desk_name == deskName && tokensList) {
                  <div>
                    @for (p of token; track p) {
                      <div class="cardtoken">
                        <div class="card-view-token" [ngClass]="p.stage == 'Serving'? 'bg-green' : ''">{{p.token}}
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>